const Ellipsis = (str, maxCharacter) => {
    if (str.length > maxCharacter) {
        return `${str.substring(0, maxCharacter)}...`

    } else {
        return str
    }

}
export default Ellipsis